import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import { Rubric } from 'styles/typography';

const PartnersContainer = styled.div`
  position: relative;
  display: block;
  
  & + * {
    margin-top: 8.8rem;
  }
  
  header {
    text-align: center;
    
    h3 {
      max-width: 108rem;
      margin: 0 auto;
    } 
    
    & + * {
      margin-top: 3.2rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    header {
      & + * {
        margin-top: 4.8rem;
      }
    }
    
    & + * {
      margin-top: 12.4rem;
    }
  }
`;

const PartnersList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  
  li {
    flex: 0 1 33.33334%; 
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    
    &:nth-of-type(n+4) {
      margin-top: 4rem;
    }
  }
  
  img {
    display: block;
    width: 100%;
    max-width: 17.4rem;
    margin: 0 auto;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    li {
      flex: 0 1 20%;
      
      &:nth-of-type(n+4) {
        margin-top: 0;
      }
      
      &:nth-of-type(n+6) {
        margin-top: 4.8rem;
      }
    }
  }
`;

const Partners = ({ partners, variant }) => {
  return (
    <PartnersContainer>
      <Inner>
        {variant && (
          <header>
            <Rubric>Latest Partners</Rubric>
          </header>
        )}

        <PartnersList>
          {partners && partners.map((partner, i) => (
            <li key={i}>
              {partner && <img src={partner.logo.url} alt={partner.logo.alt} loading="lazy" />}
            </li>
          ))}
        </PartnersList>
      </Inner>
    </PartnersContainer>
  );
};

export default Partners;
